<template>
  <div class="home-container">
    <van-image class="title" fit="contain" :src="titleUrl" />
    <van-image class="person" fit="contain" :src="personUrl" />
    <div class="login" @click="login">登录</div>
    <p class="text">WEGYMER <span class="name">@健萌智训</span></p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bgUrl:
        'https://cdnvue.gymcity.com.cn/uploads/51f1e4a2cc4fba4a49d6d68880a69d3c.png',
      personUrl:
        'https://cdnvue.gymcity.com.cn/uploads/b7cbc127e81a99f5cd304d9609ba7538.png',
      titleUrl:
        'https://cdnvue.gymcity.com.cn/uploads/4e3b80cf3586a480b7f039432e92a02f.png'
    }
  },
  methods: {
    login() {
      this.$router.push('/fatcamp/login')
    }
  }
}
</script>
<style lang="scss" scoped>
.home-container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-size: cover;
  background-position: center;
  background-image: url('https://cdnvue.gymcity.com.cn/uploads/51f1e4a2cc4fba4a49d6d68880a69d3c.png');
  .title {
    width: 76.5vw;
    margin-top: 5.5vh;
    margin-bottom: 0.6vh;
  }
  .person {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
  .login {
    text-align: center;
    width: 74.9vw;
    height: 11.7vw;
    background-color: #ffdec3;
    border-radius: 2.7vw;
    overflow: hidden;
    line-height: 11.7vw;
    font-family: PingFangSC-Medium;
    font-size: 4.8vw;
    font-weight: 600;
    letter-spacing: -0.2vw;
    color: #7e4620;
    margin: 4.2vh 0vh 4.4vh;
  }
  .text {
    font-family: PingFangSC-Regular;
    font-size: 3.2vw;
    color: #ffffff;
    margin-bottom: 4.1vh;
    .name {
      font-family: PingFangSC-Medium;
    }
  }
}
</style>
